import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import exportedConfig from '../config';

export interface GenerateLogoPromptInput {
    businessName: string;
    tagLine?: string;
    industry?: string;
    shortDescription?: string;
    businessDescription?: string;
    maxGenerations?: number;
    culture?: string;
}

export interface LogoPrompt {
    title: string;
    prompt: string;
    significance: string;
}

export interface GenerateLogoPromptResponse {
    prompts: LogoPrompt[];
}

export const postGenerateLogoPrompt = async (
    generateLogoPromptInput: GenerateLogoPromptInput,
    signal: AbortSignal,
): Promise<GenerateLogoPromptResponse> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${exportedConfig.backendServiceUrl}/api/v3/inspiration:generateLogoPrompt`,
            generateLogoPromptInput,
            {
                signal,
                headers,
            },
        );

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.prompts) {
            console.error('API Response:', response.data);
            throw new Error('API response missing prompts');
        }

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error generating image:', error);
        throw error;
    }
};
